<template>
    <div class="skins">
        <div class="skinsBox">
            <div class="skins-msg">
                <div class="skins-msg-title">本次考试已完成</div></br>
            </div>
        </div>
        <div class="footer">
            <el-button class="sub" @click="goBack()">返 回</el-button>
        </div>
    </div>
</template>
<script>
import utils from '../../lib/util'
    export default {
        name:"endBack",
        data() {
            return {
                name:'音乐测评操作示范-测试库'
            }
        },
        components:{},
        created(){},
        watch: {},
        computed:{},
        mounted(){
            
        },
        methods:{
            goBack(){
                this.$router.push({
                    path: '/myExamList',
                })
            }
        }
    }
</script>
<style scoped lang="less">
    .skins{
        height: 100%;
        width: 100%;
        background-image: url('../../../static/images/end-bg.png');
        background-repeat: no-repeat;
        background-position: 50% 22%;
        background-size: auto 59%;
        position: relative;
        .skinsBox{
            width: 100%;
            position: absolute;
            bottom: 24%;
            left: 0;
            right: 0;
            .skins-msg{
                height: 100%;
                display: inline-block;
                margin: 0 auto;
                background-image: url(data:image/png;base64,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);
                background-position: 0 50%;
                background-size: auto 70%;
                background-repeat: no-repeat;
                padding-left: 40px;
                .skins-msg-title{
                    text-align: left;
                    font-size: 2vh;
                    color: #000;
                    width: auto;
                    height: 100%;
                    line-height: 40px;
                    font-size: 22px;
                    display: inline-block;
                }
                .skins-msg-date{
                    text-align: left;
                    font-size: 0.9vw;
                    color: rgb(185, 185, 185);
                    width: auto;
                }
            }
        }
        .footer{
            position: absolute;
            bottom: 0;
            height: 18%;
            left: 0;
            right: 0;
            width: 100%;
            .sub{
                background: rgb(0, 75, 180);
                width: 30%;
                color: #FFF;
                font-size: 17px;
            }

        }
    }

</style>



// WEBPACK FOOTER //
// src/pages/exam/endBack.vue